export {default} from './ChatUserModel';
export * from './ChatUserModel';



// WEBPACK FOOTER //
// ./src/models/ChatUserModel/index.ts